import { render, staticRenderFns } from "./confirm-registration.vue?vue&type=template&id=5a32365b&scoped=true&"
import script from "./confirm-registration.vue?vue&type=script&lang=ts&"
export * from "./confirm-registration.vue?vue&type=script&lang=ts&"
import style0 from "./confirm-registration.vue?vue&type=style&index=0&id=5a32365b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a32365b",
  null
  
)

export default component.exports